import React from "react";
import {Button, Dialog, DialogActions, DialogContent, Stack, Typography, styled, Grid} from "@mui/material";
import {t, Trans} from "@lingui/macro";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {ZPlaySelect} from "../fields";
import {UseFormReturn} from "react-hook-form";
import {UserType} from "../../models";
import * as Yup from "yup";
import {withUseFormHook} from "@sinossi/mates-react-library";

interface UploadModalProps {
    confirmCallback: any
    closeModal: () => void
    header?: string[]
    errorMessage? : string
    errorMessageId? : string
    isUserCSV? : boolean
}

interface UploadModalState {
    csvFile: File | null
    showErrorMessage: boolean
    isValidCSV: boolean
}

const UploadDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
      backgroundColor: process.env.REACT_APP_THIRD_COLOR,
    }
  }));


const UploadModalFormSchema = Yup.object().shape({
});

class UploadModal extends React.Component<UploadModalProps & UseFormReturn, UploadModalState> {

    constructor(props: any) {
		super(props);

		this.state = {
			csvFile: null,
            showErrorMessage: false,
            isValidCSV: false
		};
	}

    private parseFile = (event: any) => {

        //Check fatto solo se passo un header di riferimento
        if(this.props.header) {
            this.setState(() => ({
                csvFile: event.target.files[0],
                showErrorMessage: false
            }));
            this.checkHeader(event.target.files[0])

        }else{
            this.setState(() => ({
                csvFile: event.target.files[0],
                isValidCSV: true,
                showErrorMessage: false
            }));
        }
    }

    private checkHeader = (file: File) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const csvText: string = e.target?.result as string;
            const lines: string[] = csvText.split('\n');

            // Assume che l'header si trovi nella prima riga del file CSV
            const header: string[] = lines[0].trim().split(',');

            if(!this.arraysAreEqual(header, this.props.header!)){
                this.setState(() => ({
                    showErrorMessage: true
                }))
            }else{
                this.setState(() => ({
                    isValidCSV: true
                }))
            }
        };

        reader.readAsText(file);
    }

    private arraysAreEqual = (a : string[], b : string[]) => {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;

        const sortedArr1 = [...a].sort();
        const sortedArr2 = [...b].sort();

        for (let i = 0; i < sortedArr1.length; ++i) {
            if (sortedArr1[i] !== sortedArr2[i]) return false;
        }
        return true;
    }

    private confirmCallback = () =>{

        if(this.props.isUserCSV)
            this.props.confirmCallback(this.state.csvFile!, this.props.getValues("user-type"))
        else
            this.props.confirmCallback(this.state.csvFile!)
    }

    render(){
        return(
            <UploadDialog
                open={true}
                onClose={this.props.closeModal}
                fullWidth
                maxWidth="sm"
            >
                <DialogContent>
                    <label style={{ cursor: "pointer" }}>
                        <input
                            style={{ display: "none" }}
                            color="#ffffff"
                            name="upload-csv-file"
                            type="file"
                            accept=".csv"
                            onChange={this.parseFile} />
                            <Stack height={300} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR} alignItems={"center"} justifyContent={"center"} border={"dashed 2px #ffffff"} borderRadius={1}>
                                <CloudUploadIcon sx={{fontSize: "80px"}}/>
                                {!this.state.csvFile && <Typography><Trans id="um-upload-csv-text">Trascina qui il file o clicca per caricare</Trans></Typography>}
                                {this.state.csvFile && <Typography>{this.state.csvFile!.name}</Typography>}
                            </Stack>
                    </label>
                    {this.props.isUserCSV && <Grid container xs={6} mt={1}>
                        <form>
                            <ZPlaySelect
                                label={t({
                                    id: "um-select-user-type",
                                    message: "Tipologia di utenti"
                                })}
                                name={`user-type`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                                defaultValue={UserType.FREE}
                                required={true}
                                noNullValue={true}
                            >
                                <option value={UserType.FREE}>Gratuiti</option>
                                <option value={UserType.MONTHLY}>Abbonamento mensile</option>
                                <option value={UserType.YEARLY}>Abbonamento annuale</option>
                            </ZPlaySelect>
                        </form>
                    </Grid>}
                    {this.state.showErrorMessage && this.props.errorMessage && this.props.errorMessageId && <Grid container xs={12}>
                        <Typography variant="h3" component="div" gutterBottom
                        sx={{
                            fontWeight: "bold",
                            color: "red",
                            paddingTop : "5px"
                        }}>
                            <Trans id={this.props.errorMessageId}>
                                {this.props.errorMessage}
                            </Trans>
                        </Typography>
                    </Grid>}

                </DialogContent>
                <DialogActions sx={{ p: "0 24px 20px" }}>
                    <Button
                        variant="contained"
                        size="small"
                        type="button"
                        onClick={this.confirmCallback}
                        disabled={!this.state.isValidCSV}>
                        <Trans id={"um-confirm-btn"}>
                            Carica
                        </Trans>
                    </Button>
                </DialogActions>
            </UploadDialog>
        )}
}

export default withUseFormHook<{}>(UploadModal, UploadModalFormSchema, {});